export default function initCollapse() {
    const toggleTriggerElems = document.querySelectorAll('[data-collapse-trigger]');
    toggleTriggerElems.forEach((elem) => {
        const targetElem = elem.nextElementSibling;

        function toggleTarget() {
            elem.toggleAttribute('aria-expanded');
            targetElem.toggleAttribute('aria-hidden');
        }
        function checkHash() {
            if (window.location.hash === (`#${elem.id}`)) {
                toggleTarget();
            }
        }

        if (elem.classList.contains('tw-grouparrangements-list-intro')) {
            toggleTarget();
        }

        checkHash();

        elem.addEventListener('click', (e) => {
            e.stopPropagation();
            e.preventDefault();
            toggleTarget();
        });

        window.addEventListener('hashchange', () => {
            checkHash();
        });
    });
}
